import { memo, useContext } from "react";
import PropTypes from "prop-types";
import { Configure, InstantSearch } from "react-instantsearch-dom";
import SearchAutocomplete from "app/pages/Faq/SearchAutocomplete/SearchAutocomplete";
import AppGlobalsContext from "app/AppGlobalsContext";
import "./FaqSearch.scss";
import { ALGOLIA_HITS_PER_PAGE, searchClient } from "app/utils/algolia/searchClient";

const FaqSearch = ({ algoliaFaqIndexName, onSearchResultClick = () => {}, target }) => {
	const { brand, shop } = useContext(AppGlobalsContext);

	return (
		<div className="faq-search" data-testid="faq-search">
			<InstantSearch searchClient={searchClient} indexName={algoliaFaqIndexName}>
				<Configure
					filters={`brand:'${brand}' AND shop:'${shop}'`}
					hitsPerPage={ALGOLIA_HITS_PER_PAGE}
				/>
				<SearchAutocomplete onSearchResultClick={onSearchResultClick} target={target} />
			</InstantSearch>
		</div>
	);
};

FaqSearch.propTypes = {
	algoliaFaqIndexName: PropTypes.string,
	onSearchResultClick: PropTypes.func,
	target: PropTypes.string,
};

export default memo(FaqSearch);
